import React from 'react';
import { CaretDown, CaretDownFill, CaretUpFill } from 'react-bootstrap-icons';
import { Table } from 'reactstrap';
import './QSightDataTable.css';
import { UseReportResponse } from '../Forms/hooks/useReport/useReport';
import QSightDataTablePagination from './QSightDataTablePagination';

export interface QSightDataTableProps<T, J> {
  rows: J[] | any[] | null;
  headers: DataHeader<J>[];
  cssClass?: string;
  reportState: UseReportResponse<T>; // TODO: Consider removing if not needed
}


export interface DataHeader<T> {
  data: string;
  hidden?: boolean; // TODO: This may or may not be needed
  cssClass?: string;
  toolTipText?: string;
  dataRef: keyof T;
  callback?: (params: {}) => void; // TODO: consider requiring if sortable
  sortable?: boolean;
  sortKey: string | null;
  width?: string; // Optional width for the column
}

const QSightDataTable = <T, J>({
  headers,
  cssClass = '',
  rows,
  reportState
}: QSightDataTableProps<T, J>) => {
  return (
    <div
      className={`table-responsive qsight-data-table--wrapper d-flex flex-column card card-default card-table ${reportState.loading ? 'has-loaded' : 'loading'
        }`}
    >
      <Table className={`table qsight-data-table table-sm ${cssClass}`}>
        <thead>
          <tr>
            {headers.map((header, index) => {
              const { sortable = true, sortKey } = header;

              // Just define a sort direction and use that
              let SortIcon = CaretDown;
              if (sortKey === reportState?.sortKey) {
                SortIcon = reportState?.sortOrder === 'ASC' ? CaretUpFill : CaretDownFill;
              }

              return (
                <th
                  key={index}
                  data-toggle='toolTip'
                  title={header?.toolTipText}
                  aria-sort={
                    sortKey === reportState.sortKey ? (reportState?.sortOrder === 'ASC' ? 'ascending' : 'descending') : 'ascending'
                  }
                  style={header.width ? { width: header.width } : undefined}
                >
                  {header.data}
                  {sortable ? (
                    <span
                      role='button'
                      onClick={() => {
                        // header.callback(params); // We'll improve this (maybe not)
                        reportState.setSortKey(sortKey);
                        reportState.setSortOrder(
                          reportState.sortKey === sortKey && reportState.sortOrder === 'ASC'
                            ? 'DESC'
                            : 'ASC'
                        );
                        console.log('Sort clicked');
                      }}
                    >
                      <SortIcon />
                    </span>
                  ) : null}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className='table-body'>
          {rows !== null && rows.length > 0 ? (
            rows.map((row, rowIndex) => {
              const ExtraInfo = row['extraInfo'] as React.ReactNode;
              return (
                <React.Fragment key={row.id ?? rowIndex}>
                  <tr className={rowIndex % 2 === 0 ? 'even-row' : 'odd-row'}>
                    {headers.map((headerItem, headerItemIndex) => {
                      const CellComponent = row[headerItem.dataRef as keyof J] as React.ReactNode;
                      return (
                        <td className='text-left' key={headerItemIndex}>
                          {React.isValidElement(CellComponent) ? (
                            CellComponent
                          ) : typeof CellComponent === 'function' ? (
                            React.createElement(CellComponent)
                          ) : (
                            CellComponent
                          )}
                        </td>
                      );
                    })}
                  </tr>
                  {ExtraInfo && (
                    React.isValidElement(ExtraInfo)
                      ? ExtraInfo
                      : typeof ExtraInfo === 'function'
                        ? React.createElement(ExtraInfo)
                        : null
                  )}
                </React.Fragment>
              );
            })
          ) : (
            !reportState.loading && (
              <tr>
                <td colSpan={headers.length} className='text-center py-4'>
                  <div className='mb-0'>
                    No results found based on the current filters applied
                  </div>
                </td>
              </tr>
            )
          )}
        </tbody>
      </Table>
      
      {rows && rows.length > 0 && (
      <QSightDataTablePagination currentPage={1} totalPages={10} reportState={reportState} />
      )}

      {/* Tag in Gerell. We should do something better or at least gain alignment, but this demonstrates the intent */}
      {reportState.loading && (
        <div className='spinner-border' role='status'>
          <span className='sr-only'>Loading...</span>
        </div>
      )}
    </div>
  );
};

export default QSightDataTable;
